import { z } from 'zod';

/**
 * 利用者新規作成フォームの Zod スキーマ
 */
export const userFormSchema = z.object({
  fullName: z.string().min(1, '氏名を入力してください'),
  email: z
    .string()
    .min(1, 'メールアドレスを入力してください')
    .email('有効なメールアドレスを入力してください'),
  branchId: z.string().optional(),
  billableFrom: z
    .date({ invalid_type_error: '利用開始日を選択してください。' })
    .nullable()
    .refine(v => v !== null, { message: '利用開始日を選択してください。' })
    .transform(v => v as Date),
});

export type CreateUserFormValues = z.infer<typeof userFormSchema>;
